import { Observable } from 'rxjs';
import { ToastaService } from 'ngx-toasta';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserCredentials } from '../../models/UserCredentials';
import { AuthenticationService } from '../../../modules/authentication/authentication.service';
import { SocketDataStatus, SocketDataType } from '../../models/SocketData';
import { SocketGuard } from './socket.guard';
import { Namespace, SocketService } from './socket.service';
import { CurrentContextService } from '../../redux/current-context/service/current-context.service';
import { EntitySearchResultService } from '../../redux/search-result/service/entity-search-result.service';

@Injectable({
  providedIn: 'root'
})
export class EntityTypeSocketGuard extends SocketGuard {

  constructor(
    socketService: SocketService,
    private toastaService: ToastaService,
    private translateService: TranslateService,
    private authenticationService: AuthenticationService,
    private currentContextService: CurrentContextService,
    private entitySearchResultService: EntitySearchResultService
  ) {
    super(socketService);
  }

  onMessage = (datas: any) => {
    console.log(datas);
    const type = datas.type;
    const id = datas.id;
    const action = datas.action;

    if (type === SocketDataType.ENTITY) {
      this.onEntityMessage(type, id, action, datas);
    }
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return super.canActivate(next, state);
  }

  canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return super.canDeactivate(component, currentRoute, currentState, nextState);
  }

  private onEntityMessage(type: any, id: any, action: any, datas: any) {
    let toastaMsg: string;
    const userCredentials: UserCredentials = this.authenticationService.getUserCredentials();
    if (userCredentials.id === datas.userId || datas.status === SocketDataStatus.FAILED) {
      return;
    }

    if (false) { // désactivation des toaster entités
      if (datas.status === SocketDataStatus.COMPLETED) {
        switch (action) {
          case 'CREATE':
            toastaMsg = 'TOASTER_MESSAGES.[EntityDetails].ADD_ENTITY_SUCCEEDED';
            break;
          case 'UPDATE':
            toastaMsg = 'TOASTER_MESSAGES.[EntityDetails].UPDATE_ENTITY_SUCCEEDED';
            if (this.getRoom() === this.currentContextService.getCurrentEntityType()) {
              this.entitySearchResultService.updateStoreEntity(id);
            }
            break;
          case 'DELETE':
            toastaMsg = 'TOASTER_MESSAGES.[EntityDetails].DELETE_ENTITY_SUCCEEDED';
            if (this.getRoom() === this.currentContextService.getCurrentEntityType()) {
              this.entitySearchResultService.deleteStoreEntity(id);
            }
            break;
        }
        this.toastaService.info(this.translateService.instant(toastaMsg));
      }
    }
  }

  initNamespace(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Namespace {
    return Namespace.entities;
  }

  initRoom(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    return next.parent.paramMap.get('entityType');
  }


}
